import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`14. Disclosure to Law Enforcement`}</h2>
    <p>{`HostJane may disclose User information to law enforcement agencies without further consent
or notification to the User upon lawful request from such agencies. We cooperate fully with
law enforcement agencies.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      